/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import Options from './Options';
import TankTypeResponse from './TankTypeResponse';

/**
* The GetTankTypeResponse model module.
* @module model/GetTankTypeResponse
* @version 2020-12-7
*/
export default class GetTankTypeResponse {
    /**
    * Constructs a new <code>GetTankTypeResponse</code>.
    * タンクタイプ取得レスポンス
    * @alias module:model/GetTankTypeResponse
    * @class
    * @param tankType {module:model/TankTypeResponse} 
    * @param result {module:model/GetTankTypeResponse.ResultEnum} 
    */

    constructor(tankType, result) {
        
        
        this['tankType'] = tankType;
        this['result'] = result;
        
    }

    /**
    * Constructs a <code>GetTankTypeResponse</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/GetTankTypeResponse} obj Optional instance to populate.
    * @return {module:model/GetTankTypeResponse} The populated <code>GetTankTypeResponse</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new GetTankTypeResponse();
                        
            
            if (data.hasOwnProperty('tankType')) {
                obj['tankType'] = TankTypeResponse.constructFromObject(data['tankType']);
            }
            if (data.hasOwnProperty('result')) {
                obj['result'] = ApiClient.convertToType(data['result'], 'String');
            }
            if (data.hasOwnProperty('options')) {
                obj['options'] = Options.constructFromObject(data['options']);
            }
        }
        return obj;
    }

    /**
    * @member {module:model/TankTypeResponse} tankType
    */
    'tankType' = undefined;
    /**
    * @member {module:model/GetTankTypeResponse.ResultEnum} result
    */
    'result' = undefined;
    /**
    * @member {module:model/Options} options
    */
    'options' = undefined;



    /**
    * Allowed values for the <code>result</code> property.
    * @enum {String}
    * @readonly
    */
    static ResultEnum = {
        /**
         * value: "NG"
         * @const
         */
        "NG": "NG",
        /**
         * value: "OK"
         * @const
         */
        "OK": "OK"    };

}
